
export default function FeaturedVideo() {
  return (
    <section className="py-12 md:py-24 px-4 md:px-8 bg-gray-50 overflow-x-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            {/* 16:9 thumbnail — full width on mobile */}
            <div className="w-full lg:w-3/5 relative" style={{ paddingBottom: 'calc(56.25% * (1 - 0px))' }}>
              <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                <img
                  src="https://public.readdy.ai/ai/img_res/54a85046661e0f234d9045a2a7553fc0.jpg"
                  alt="How to Tile a Floor - Featured Tutorial"
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                  <div className="w-16 h-16 md:w-20 md:h-20 bg-[#F2C612] rounded-full flex items-center justify-center hover:scale-110 transition-transform cursor-pointer">
                    <i className="ri-play-fill text-3xl md:text-4xl text-[#1A1A1A]"></i>
                  </div>
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="w-full lg:w-2/5 p-6 md:p-8 lg:p-12 flex flex-col justify-center">
              <div className="mb-4">
                <span className="text-xs font-semibold px-3 py-1 rounded-full bg-green-100 text-green-700 whitespace-nowrap">
                  Most Popular
                </span>
              </div>
              <h2
                className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4 leading-tight"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                How to Tile a Floor
              </h2>
              <p className="text-gray-600 mb-6 text-sm md:text-base leading-relaxed">
                Our most-watched tutorial covers everything from surface preparation to the final grout application. Perfect for first-time tilers and experienced DIYers looking to refine their technique.
              </p>
              <div className="flex items-center gap-4 text-sm text-gray-500 mb-6 flex-wrap">
                <span className="flex items-center gap-2">
                  <i className="ri-time-line"></i>
                  18 minutes
                </span>
                <span className="flex items-center gap-2">
                  <i className="ri-eye-line"></i>
                  127K views
                </span>
              </div>
              <button className="w-full lg:w-auto min-h-[48px] bg-[#F2C612] text-[#1A1A1A] px-8 py-3 rounded-lg font-semibold hover:bg-[#d4ad0a] transition-colors whitespace-nowrap cursor-pointer">
                Watch Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
